export const cities = [
  "hamburg",
  "bremen",
  "berlin",
  "ruhrgebiet",
  "rheinland",
];
